import HTTP from "../../../../../webservice/http";

class APIList {
  constructor() {}
  //  login will be required once when we enter over the dashboard
  // userAuthLogin(params) {
  //   return HTTP.POST("api_auth/token/", params);
  // }
  // getProfileData() {
  //   return HTTP.GET("user/profile");
  // }

  // street Light
  getStreetLight() {
    return HTTP.GET("street-lights/");
  }

  getStreetLightDetails(uuid) {
    return HTTP.GET(`street-lights/${uuid}/`);
  }

  getStreetLightHistory(uuid) {
    return HTTP.GET(`street-lights/${uuid}/history/`);
  }

  createStreetLight(params) {
    return HTTP.POST("street-lights/", params);
  }

  updateStreetLight(params, uuid) {
    return HTTP.PUT(`street-lights/${uuid}/`, params);
  }

  // street light report

  getConsolidated() {
    return HTTP.GET("street-lights/status/consolidated/");
  }

  getEnergyConsumption() {
    return HTTP.GET("street-lights/status/energy-consumption/");
  }

  getNetworkEnergyConsumption() {
    return HTTP.GET(
      "street-lights/status/network-energy-consumption/?start_date=2024-01-01&end_date=2024-09-10&use_cache=false"
    );
  }

  getOperationalEfficiency() {
    return HTTP.GET(
      "street-lights/status/operational-efficiency/?start_date=2024-01-01&end_date=2024-09-10&use_cache=false"
    );
  }
  getPredictionFault() {
    return HTTP.GET("street-lights/status/prediction-fault/");
  }

  getInsights() {
    return HTTP.GET(
      "street-lights/status/insights/?latitude=12.9716&longitude=77.5946"
    );
  }
}

export default new APIList();
